// extracted by mini-css-extract-plugin
export var gridWrapperStyle = "rsc_hub_card_wrapper-module--gridWrapperStyle--DTfeN";
export var isLandscapeStyle = "rsc_hub_card_wrapper-module--isLandscapeStyle--Pw+zu";